var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Pengaturan Pengumuman" } },
        [
          _c(
            "b-card-text",
            [
              _c(
                "b-button",
                {
                  staticClass: "btn-sm",
                  attrs: { variant: "primary" },
                  on: { click: _vm.addPengumuman },
                },
                [
                  _c("b-icon", { attrs: { icon: "plus" } }),
                  _vm._v(" Tambah Data"),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "mt-3",
                attrs: { id: "table-pengumuman" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }